/* Dansk katalog for locale-no.js (del 8 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'po.todaysPlanBase': 'Dagens plan — udgangspunktet',
  'po.editTodaysPlan': 'Rediger dagens plan',
  'po.netWealthToday': 'Nettoformue i dag',
  'po.monthlySavingShort': 'Månedlig opsparing',
  'po.extraDebtRepayment': 'Ekstra gældsafdrag',
  'po.return': 'Afkast',
  'po.retirementAge': 'Pensionsalder',
  'po.adjustAssumptions': 'Justér forudsætninger',
  'po.lifeEvents': 'Livsbegivenheder',
  'po.lifeEventsSub': 'Planlæg store begivenheder fremover — børn, bolig, orlov, sabbatår — og se, hvordan de former hele fremtidsbilledet',
  'po.addEvent': 'Tilføj begivenhed',
  'po.lifeEventsHelp': 'Indtast fremtidige begivenheder med startdato, engangsomkostning, månedlig effekt og varighed. Hver aktiv begivenhed indsættes på det rigtige tidspunkt i prognosen. Slå en begivenhed fra for at se planen uden den. Begivenhederne gemmes for det valgte år.',
  'po.effectOver5Years': 'Effekt over 5 år',
  'po.goalScore': 'Målscore',
  'po.goalScoreSub': 'Hvor godt du ligger til at nå dine mål — og hvad der løfter scoren',
  'po.whatAffectsGoalScore': 'Dette påvirker målscoren',
  'po.myRecommendationNow': 'Min anbefaling lige nu',
  'po.prioritise': 'Prioritér',
  'po.talkAboutPlan': 'Tal med mig om planen',
  'po.yourGoals': 'Dine mål',
  'po.yourGoalsSub': 'Hvert mål med resterende beløb, forventet dato og sandsynlighed',
  'po.newGoal': 'Nyt mål',
  'po.addGoal': 'Tilføj mål',
  'po.editGoal': 'Rediger mål',
  'po.deleteGoal': 'Slet mål',
  'po.remaining': 'Tilbage',
  'po.expectedDone': 'Forventet færdig',
  'po.probability': 'Sandsynlighed',
  'po.largestEffect': 'Størst effekt',
  'po.howReachFaster': 'Hvad kan jeg gøre for at nå dette hurtigere?',
  'po.nextMilestone': 'Næste milepæl',
  'po.nextMilestoneSub': 'Det, du sandsynligvis opnår først — i kronologisk rækkefølge',
  'po.yourLifePlan': 'Din livsplan',
  'po.yourLifePlanSub': 'De vigtigste økonomiske milepæle fremover, bygget ud fra dine mål og din plan',
  'po.adjustLive': 'Justér forudsætningerne — prognosen, målene og datoerne opdateres i realtid, mens du trækker.',
  'po.deleteGoalTitle': 'Slet målet?',
  'po.deleteGoalConfirm': 'Slet målet',
  'po.doYouWantToDelete': 'Vil du slette',
  'po.ownPartnerSharedSub': 'Oversigt over egne, partnerens og fælles udgifter',
  'po.you': 'Dig',
  'po.partner': 'Partner',
  'po.householdSpends': 'Husstanden bruger',
  'po.reportSub': 'Se, sammenlign, udskriv og download måneds- og årsrapporter',
  'po.print': 'Udskriv',
  'po.downloadPdf': 'Download PDF',
  'po.pdfBusy': 'Opretter PDF …',
  'po.pdfFailed': 'Kunne ikke oprette PDF af rapporten. Prøv igen, eller brug Udskriv.',
  'po.pdfFileName': 'privatokonomi-rapport',
  'po.compareWith': 'Sammenlign med',
  'po.compareHelp': 'Læg en tidligere periode ved siden af for at se ændringen. »Fra« viser kun den valgte periode.',
  'po.ongoingPeriod': 'Igangværende periode — tallene er foreløbige',
  'po.plummaSummary': 'SuperPlummas opsummering',
  'po.wentWell': 'Det gik godt',
  'po.canImprove': 'Det kan forbedres',
  'po.focusNextMonth': 'Fokus næste måned:',
  'po.goDeeper': 'Vil du gå mere i dybden? Spørg mig om rapporten.',
  'po.plummaNoticed': 'SuperPlumma bemærkede',
  'po.savingsRate': 'Opsparingsrate',
  'po.noImportedCosts': 'Ingen importerede udgifter',
  'po.totalCosts': 'Sum udgifter',
  'po.whatHappensNext': 'Hvad sker der nu?',
  'po.setAsideOver12': 'Sat til side på 12 md.',
  'po.averagePerMonth': 'Gennemsnit pr. måned',
  'po.askWhatHappensNext': 'Spørg mig, hvad der sker nu',
  'po.whatFiguresMean': 'Hvad tallene betyder',
  'po.youHaveStated': 'Du har oplyst, at',
  'po.howItLooksAhead': 'Sådan ser det ud fremover',
  'po.inSixMonths': 'Om 6 måneder',
  'po.inTwelveMonths': 'Om 12 måneder',
  'po.assetCategoryPh': 'F.eks. Fast ejendom',
  'po.assetsAndWealth': 'Aktiver og formue',
  'po.assetsAndWealthSub': 'Alt, hvad du ejer, samlet — bolig, køretøjer, opsparing og investeringer',
  'po.assetsHelp': 'Den samlede værdi af det, du ejer, din gæld og nettoformuen (aktiver minus gæld). »Forventet værdiændring« summerer, hvordan aktiverne ventes at stige eller falde i værdi i løbet af året.',
  'po.totalAssets': 'Samlede aktiver',
  'po.netWealth': 'Nettoformue',
  'po.expectedChangePerYear': 'Forventet værdiændring pr. år',
  'po.liquid': 'Likvid (opsparing og fonde)',
  'po.assetCount': 'Antal aktiver',
  'po.wealthHealth': 'Formuesundhed',
  'po.wealthHealthSub': 'Samlet vurdering af, hvor robust din formue er — diversificering, likviditet, risiko og gældsgrad',
  'po.wealthStrongestOn': 'Din formue scorer højest på',
  'po.wealthDistribution': 'Hvordan din formue er fordelt på kategorier',
  'po.expectedDevelopment': 'Forventet udvikling',
  'po.expectedDevelopmentSub': 'Baseret på den værdiændring, du selv har angivet pr. aktiv',
  'po.projectionHelp': 'Fremskrivningen bruger den forventede årlige værdiændring, du har angivet for hvert aktiv. Plumme henter endnu ikke eksterne markedsdata for bolig, brugt bil eller fonde.',
  'po.withYourAssumptions': 'Med de forudsætninger, du har indtastet, ændrer din formue sig med omkring',
  'po.explainSimply': 'Forklar udviklingen enkelt',
  'po.watchingClosely': 'Følges ekstra nøje',
  'po.watchingCloselySub': 'De aktiver, der ventes at tabe værdi eller vokse langsommere end inflationen',
  'po.explain': 'Forklar',
  'po.yourAssets': 'Dine aktiver',
  'po.yourAssetsSub': 'Tryk på et aktiv for at redigere værdi og detaljer',
  'po.addAsset': 'Tilføj aktiv',
  'po.askAboutTax': 'Spørg mig om skatten',
  'po.taxAssistant': 'Skattemelding-assistent',
  'po.taxAssistantSub': 'SuperPlumma guider dig trin for trin og tilpasser spørgsmålene undervejs',
  'po.deductionHunter': 'Fradragsjæger',
  'po.deductionHunterSub': 'Fradragene sorteres efter forventet værdi — start øverst, hvor gevinsten er størst',
  'po.whyIThinkThis': 'Hvorfor mener jeg det?',
  'po.dataIUsed': 'Data, jeg har brugt',
  'po.whyYouQualify': 'Hvorfor du har ret til fradraget',
  'po.estimatedTaxBenefit': 'Anslået skattefordel',
  'po.taxOptimisation': 'Skatteoptimering',
  'po.taxOptimisationSub': 'Konkrete tiltag sorteret efter frist — og hvad de betyder for i år og næste år',
  'po.nextYearOnwards': 'Næste år og fremover',
  'po.aiTaxCheck': 'AI-skattekontrol',
  'po.aiTaxCheckSub': 'SuperPlumma gennemgår dine importerede skatteoplysninger',
  'po.readyToFile': 'Klar til ekstern kontrol',
  'po.readyToFileSub': 'Sammenlign grundlaget med skattemeldingen og årsopgørelserne',
  'po.checkBasis': 'Kontrolgrundlag',
  'po.requiresIntegration': 'Kræver officiel integration, stærk autentificering og udtrykkelig godkendelse',
  'po.filingUnavailable': 'Indsendelse ikke tilgængelig',
  'po.whatIsMissing': 'Hvad mangler før ekstern kontrol?',
  'po.whatRemains': 'Det her mangler',
  'po.taxBasisNotFetched': 'Skattegrundlaget er ikke hentet ind',
  'po.alreadyVerified': 'Allerede kvalitetssikret',
  'po.nothingVerified': 'Intet er kvalitetssikret endnu.',
  'spx.taxScheme': 'Skatte- og afgiftsordning',
  'spx.noItems': 'Ingen poster registreret endnu.',
  'spx.removeSpec': 'Fjern specifikation',
  'prd.import': 'Importér produkter',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Eksportér produkter',
  'prd.csvName': 'Produkter CSV',
  'prd.excelName': 'Produkter Excel',
  'prd.countTemplateName': 'Skabelon til vareoptælling',
  'prd.countTemplateEmpty': 'Ingen varer at tælle. Optællingsskabelonen medtager produkter af typen Vare.',
  'prd.countTemplateDone': 'Optællingsskabelonen er downloadet. Udfyld antal pr. 31.12., og husk, at lageret værdiansættes til indkøbspris.',
  'prd.countTemplateError': 'Optællingsskabelonen kunne ikke laves.',
  'prd.colProductId': 'Produkt-ID',
  'prd.colInventoryAccount': 'Lagerkonto',
  'prd.colStockToday': 'Beholdning i dag',
  'prd.colCountedQuantity': 'Optalt antal',
  'prd.colTotalCostValue': 'Samlet kostværdi',
  'prd.colNote': 'Bemærkning',
  'prd.countSheetTitle': 'Vareoptælling',
  'prd.countSheetIntro': 'Antal og vareforbrug er forudfyldt fra dagens produktregister. Kontrollér og ret mod den faktiske optælling på optællingsdatoen.',
  'prd.countSheetDate': 'Optællingsdato',
  'prd.countSheetCountedBy': 'Optalt af',
  'prd.countSheetReference': 'Reference',
  'prd.countSheetSignature': 'Underskrift',
  'prd.countSheetNoteLabel': 'Bemærk',
  'prd.countSheetNote': 'Denne liste dokumenterer optællingen. Regnskabsmæssig værdi og skattemæssig værdi vurderes i årsafslutningen.',
  'prd.countSheetInfoTab': 'Information',
  'prd.countSheetWrongTemplate': 'Brug optællingsskabelonen fra Plumme. Kolonnerne stemmer ikke.',
  'prd.countSheetOnlyXlsx': 'Automatisk indlæsning understøtter Excel-skabelonen (.xlsx). Andre filer gemmes som dokumentation.',
  'prd.countSheetTabNotFound': 'Arket {name} blev ikke fundet.',
  'prd.countSheetRowError': 'Række {row}: Kontrollér vare, lagerkonto, optalt antal og vareforbrug.',
  'prd.countSheetNoneCounted': 'Der blev ikke fundet nogen udfyldte antal i optællingslisten.',
  'prd.countSheetUnmappedAccount': 'Lagerkonto {account} kan ikke fordeles automatisk. Kontrollér kontiene i gennemgangen.',
  'prd.filterHelp': 'Filtrér produkterne efter type (vare, ydelse, udlejning), om de er på lager, og om slettede skal vises.',
  'prd.listTitle': 'Produktliste',
  'prd.listSub': 'Varer og ydelser, du sælger',
  'prd.new': 'Nyt produkt',
  'prd.searchPh': 'Søg på produktnavn, beskrivelse, varenummer eller pris',
  'prd.searchHelp': 'Søg på produktnavn, beskrivelse, varenummer eller pris.',
  'prd.none': 'Ingen produkter her endnu',
  'prd.listHelpTitle': 'Produktlisten',
  'prd.listHelp': 'Hver række er ét produkt med varenr., pris, momssats, type og lagerbeholdning. Tryk på en række for at se detaljer og redigere.',
  'prd.detailsTitle': 'Produktdetaljer',
  'prd.detailsHelp': 'Beskrivelse, varenummer, pris ekskl. moms, momssats, type og lagerbeholdning for produktet.',
  'prd.editHelp': 'Ændr navn, pris, moms, type og lager for produktet.',
  'prd.delete': 'Slet produkt',
  'prd.deleteHelp': 'Flyt produktet til slettede. Du kan gendanne det senere.',
  'prd.itemNo': 'Varenr.',
  'prd.colStockItem': 'Vare',
  'prd.stockReasonDefault': 'Fysisk optælling',
  'prd.stock': 'Lager',
  'prd.deleted': 'Slettet',
  'prd.pickOwnColour': 'Vælg egen farve',
  'prd.namePh': 'F.eks. Konsulenttime',
  'prd.priceExVat': 'Pris ekskl. moms',
  'prd.price': 'Pris',
  'prd.priceIncVat': 'Pris inkl. moms',
  'prd.subscriptionPeriod': 'Abonnementsperiode',
  'prd.multiDayDiscount': 'Flerdagsrabat',
  'prd.multiDayHelp': 'Gælder kun dette udlejningsprodukt.',
  'prd.day2ChargedAt': 'Dag 2 opkræves med',
  'prd.day3Onwards': 'Dag 3 og fremefter',
  'prd.itemNumber': 'Varenummer',
  'prd.accountFallbackName': 'Konto',
  'prd.acct3000': 'Salg og udtag med momspligt',
  'prd.acct3020': 'Salgsindtægt ydelser, høj momssats',
  'prd.acct3030': 'Salgsindtægt varer, mellemste momssats',
  'prd.acct3050': 'Salgsindtægt varer, lav momssats',
  'prd.acct3100': 'Salg og udtag med 0 procent moms',
  'prd.acct3200': 'Salg og udtag uden for mva-loven',
  'prd.acct3900': 'Andre driftsindtægter',
  'prd.colProductName': 'Produktnavn',
  'prd.colDescription': 'Beskrivelse',
  'prd.colVat': 'Moms',
  'prd.colType': 'Type',
  'prd.colRentalDiscount': 'Udlejningsrabat',
  'prd.colSalesAccount': 'Salgskonto',
  'prd.colEquivalentAccount': 'Svarer til standardkonto',
  'prd.excelImportUnavailable': 'Excel-import er ikke tilgængelig endnu.',
  'prd.excelExportUnavailable': 'Excel-eksport er ikke tilgængelig endnu.',
  'prd.colStatus': 'Status',
  'prd.exportSheetName': 'Produkter',
  'prd.typeHeading': 'Overskrift',
  'prd.typeTextLine': 'Tekstlinje',
  'prd.textLinesTitle': 'Tekstlinjer',
  'prd.newTextLine': 'Ny tekstlinje',
  'prd.updateTextLine': 'Opdatér tekstlinje',
  'prd.saveTextLine': 'Gem tekstlinje',
  'prd.textLineNamePh': 'F.eks. Standardtekst til montering',
  'prd.textLineTextPh': 'Skriv den tekst, der skal kunne bruges på dokumentlinjer',
  'prd.styleFor': 'Stil for {target}',
  'prd.styleTargetText': 'Tekst',
  'prd.styleTargetName': 'Navn',
  'prd.styleBold': 'Fed',
  'prd.styleItalic': 'Kursiv',
  'prd.styleDivider': 'Skillelinje',
  'prd.styleNoDivider': 'Uden skillelinje',
  'prd.styleSummary': 'Navn: {name} · Tekst: {text} · {divider}',
  'prd.toastProductUpdated': 'Produkt opdateret',
  'prd.toastProductSaved': 'Produkt gemt',
  'prd.toastProductSaveError': 'Produktet kunne ikke gemmes.',
  'prd.toastProductDeleted': 'Produkt slettet',
  'prd.toastProductDeleteError': 'Produktet kunne ikke slettes.',
  'prd.toastTextLineUpdated': 'Tekstlinje opdateret',
  'prd.toastTextLineSaved': 'Tekstlinje gemt',
  'prd.toastTextLineSaveError': 'Tekstlinjen kunne ikke gemmes.',
  'prd.toastTextLineDeleted': 'Tekstlinje slettet',
  'prd.toastTextLineDeleteError': 'Tekstlinjen kunne ikke slettes.',
  'prd.toastImportNoneFound': 'Der blev ikke fundet nogen produkter i filen.',
  'prd.toastImportSuccess': '{count} produkter importeret',
  'prd.toastImportError': 'Produkterne kunne ikke importeres.',
  'prd.toastExportNone': 'Ingen produkter at eksportere',
  'prd.toastExportDone': 'Produktliste downloadet',
  'prd.toastExportError': 'Produktlisten kunne ikke eksporteres.',
  'prd.textLineFilterHelp': 'Filtrér gemte tekstlinjer og overskrifter.',
  'prd.filterOther': 'Andet',
  'prd.showDeleted': 'Vis slettede',
  'prd.typeGoods': 'Vare',
  'prd.typeService': 'Ydelse',
  'prd.typeRental': 'Udlejning',
  'prd.typeSubscription': 'Abonnement',
  'prd.stockOnly': 'Kun på lager',
  'prd.textLineSubtitle': 'Gemte tekster og overskrifter til salgsdokumenter',
  'prd.titleHelp': 'Dine produkter — varer og ydelser, du sælger, med pris, moms og lager. Tryk på et produkt for detaljer.',
  'prd.uploadHelp': 'Importér produkter fra en fil.',
  'prd.downloadHelp': 'Download produktlisten som CSV eller Excel.',
  'prd.addHelp': 'Tilføj en ny vare, ydelse, et abonnement eller et udlejningsprodukt.',
  'prd.textLineSearchPh': 'Søg på navn, tekst eller type',
  'prd.textLineSearchHelp': 'Søg i gemte tekstlinjer og overskrifter.',
  'prd.emptyText': 'Tilføj varer og ydelser, du sælger, så går faktureringen lynhurtigt.',
  'prd.textLineEmptyTitle': 'Ingen tekstlinjer endnu',
  'prd.textLineEmptyText': 'Gem faste tekster, overskrifter og produkttekster uden pris.',
  'prd.colBalance': 'Beholdning',
  'prd.colCostPerUnit': 'Vareforbrug pr. enhed',
  'prd.colTotalValue': 'Samlet værdi',
  'prd.colStockAvailable': 'Lager/tilgængeligt',
  'prd.noneShort': 'Ingen',
  'prd.subscriptionLabel': 'Abonnement · {period}',
  'prd.month1Short': '1 md.',
  'prd.months12Short': '12 mdr.',
  'prd.copyToTextLine': 'Kopiér til tekstlinje',
  'prd.colProduct': 'Produkt',
  'prd.colPrice': 'Pris',
  'prd.colName': 'Navn',
  'prd.colStyle': 'Stil',
  'prd.errNrTaken': 'Varenummeret »{nr}« er allerede i brug.',
  'prd.errAccountCodeFormat': 'Brug en indtægtskonto, der starter med 3 og har 4 eller 5 cifre.',
  'prd.errAccountNameRequired': 'Giv kontoen et navn.',
  'prd.errAccountEquivalentRequired': 'Vælg den standardkonto, denne skal svare til.',
  'prd.errAccountExists': 'Konto {code} findes allerede.',
  'prd.errCostPriceInvalid': 'Kostprisen skal være et gyldigt beløb på mindst 0.',
  'prd.errTrackingDateRequired': 'Vælg den dato, hvor automatisk lagerstyring skal starte.',
  'prd.errStockNegative': 'Startbeholdningen kan ikke være negativ.',
  'prd.errCostPriceRequired': 'Indtast kostpris for startbeholdningen.',
  'prd.errCostPriceNegative': 'Kostprisen kan ikke være negativ.',
  'prd.noName': 'Uden navn',
  'prd.updateProduct': 'Opdatér produkt',
  'prd.saveProduct': 'Gem produkt',
  'prd.rentalQtyLabel': 'Antal tilgængelige til udlejning',
  'prd.autoInventoryTitle': 'Automatisk lager og vareforbrug',
  'prd.autoInventoryHelp': 'Indkøb øger lageret. Bogførte salg reducerer lageret og bogfører beregnet vareforbrug efter vægtet gennemsnit.',
  'prd.calculatedStock': 'Beregnet lagerbeholdning',
  'prd.openingStock': 'Startbeholdning',
  'prd.avgCostPrice': 'Gennemsnitlig kostpris',
  'prd.costPerUnit': 'Kostpris pr. enhed',
  'prd.inventoryValueLine': 'Lagerværdi: {value}',
  'prd.month1': '1 måned',
  'prd.months12': '12 måneder',
  'prd.advancedTitle': 'Avancerede produktdata',
  'prd.advancedHelp': 'SKU, EAN/GTIN, produktgruppe og importdata.',
  'prd.noGroup': 'Ingen gruppe',
  'prd.removeGroup': 'Fjern produktgruppe',
  'prd.newGroupPh': 'Ny produktgruppe',
  'prd.brand': 'Mærke',
  'prd.variantName': 'Variantnavn',
  'prd.supplierItemNumber': 'Leverandørens varenr.',
  'prd.internalReference': 'Intern reference',
  'prd.tags': 'Tags',
  'prd.tagsPh': 'F.eks. webshop, reservedel, vinter',
  'prd.saveAsTextLineTitle': 'Gem også som tekstlinje',
  'prd.saveAsTextLineHelp': 'Opretter en kopi uden pris til dokumentlinjer.',
  'prd.autoAccountLine': 'Automatisk: {account}',
  'prd.accountTypeLabel': 'Kontotype',
  'prd.selectAccount': 'Vælg konto',
  'prd.customAccountOption': 'Brugerdefineret',
  'prd.accountInLedger': 'Konto i regnskabet',
  'prd.accountNamePh': 'Viderefakturering',
  'prd.equivalentForYearEnd': 'Svarer til for årsregnskab/skat',
  'prd.selectStandardAccount': 'Vælg standardkonto',
  'sub.tabsHelp': 'Skift mellem abonnementer med tilbagevendende fakturering og kundelister til samlet fakturering eller e-mail.',
  'sub.start': 'Start',
  'sub.end': 'Slut',
  'sub.endHelp': 'Lad feltet stå tomt for at fortsætte, indtil abonnementet sættes på pause eller slettes.',
  'sub.internalComment': 'Intern kommentar',
  'sub.saveCustomers': 'Gem kunder',
  'sub.searchCustomers': 'Søg efter kunder',
  'sub.searchCustomersPh': 'Søg efter navn, e-mail eller org.nr....',
  'sub.selectVisible': 'Vælg synlige',
  'sub.deselectVisible': 'Fravælg synlige',
  'sub.noCustomers': 'Ingen kunder endnu',
  'sub.howToInvoice': 'Hvordan vil du fakturere?',
  'sub.manualFlowNote': 'Valget nedenfor starter et manuelt fakturaforløb for abonnementet.',
  'sub.sendInvoice': 'Send faktura',
  'sub.openDraftFilled': 'Åbn en fakturakladde med abonnementet udfyldt.',
  'sub.openBlankDraft': 'Åbn en tom fakturakladde med kundeudvalget valgt.',
  'sub.subject': 'Emne',
  'sub.message': 'Besked',
  'sub.removeAllAttachments': 'Fjern alle vedhæftninger',
  'sub.addCustomers': 'Tilføj kunder',
  'sub.noInvoiceSent': 'Ingen faktura sendt',
  'sub.noEmailSent': 'Ingen e-mail sendt',
  'sub.unknownCustomer': 'Ukendt kunde',
  'sub.customersCount': '{count} kunder',
  'sub.cpiAnnualSuffix': ' · FPI {rate} % årligt',
  'sub.actionMenuLabel': 'Handling',
  'sub.nameRequiredSubscription': 'Giv abonnementet et navn',
  'sub.nameRequiredList': 'Giv listen et navn',
  'sub.nameRequiredListError': 'Giv listen et navn.',
  'sub.nameRequiredAgreementError': 'Giv aftalen et navn.',
  'sub.editSubTitle': 'Redigér abonnement',
  'sub.editListTitle': 'Redigér liste',
  'sub.newSubTitle': 'Nyt abonnement',
  'sub.newListTitle': 'Ny liste',
  'sub.saveChanges': 'Gem ændringer',
  'sub.saveSubscription': 'Gem abonnement',
  'sub.saveList': 'Gem liste',
  'sub.namePlaceholderSub': 'F.eks. Guldmedlemskab',
  'sub.namePlaceholderList': 'F.eks. Nyhedsbrev',
  'sub.nextInvoiceDateLabel': 'Næste fakturadato',
  'sub.cpiAdjustmentLabel': 'FPI-regulering',
  'sub.cpiAdjustmentHelp': 'Årlig forbrugerprisregulering af abonnementsprisen.',
  'sub.customerSavedToast': 'Kunden "{name}" er gemt',
  'sub.saveCustomerError': 'Kunden kunne ikke gemmes.',
  'sub.addCustomersTitle': 'Tilføj kunder · {name}',
  'sub.selectedCount': '{count} valgt',
  'sub.addAsNewCustomer': 'Tilføj »{name}« som ny kunde',
  'sub.noContactInfo': 'Ingen kontaktoplysninger',
  'sub.addCustomersEmptyText': 'Tilføj først kunder i kunderegistret, eller skriv et navn for at oprette en ny kunde.',
  'sub.sendInvoiceTitle': 'Send faktura · {name}',
  'sub.attachmentTooLarge': 'Vedhæftninger må højst være {max}.',
  'sub.fillSubject': 'Udfyld emne.',
  'sub.writeMessage': 'Skriv en besked.',
  'sub.sendEmailTitle': 'Send e-mail · {name}',
  'sub.sending': 'Sender...',
  'sub.sendEmailButton': 'Send e-mail',
  'sub.readyCount': '{count} klar',
  'sub.attachmentsAddedCount': '{count} vedhæftninger tilføjet',
  'sub.addAttachment': 'Tilføj vedhæftning',
  'sub.emailSendNote': 'E-mail sendes via backend. Du kan slippe filer hvor som helst i dialogen eller indsætte med Ctrl+V. Modtagere uden e-mailadresse logges som ikke sendt.',
  'sub.typeSubscription': 'Abonnement',
  'sub.typeList': 'Liste',
  'sub.actionClose': 'Luk',
  'sub.actionOpen': 'Åbn',
  'sub.edit': 'Redigér',
  'sub.emailLabel': 'E-mail',
  'sub.resume': 'Genoptag',
  'sub.pause': 'Pause',
  'sub.delete': 'Slet',
  'sub.tabCustomers': 'Kunder ({count})',
  'sub.tabInvoices': 'Fakturaer ({count})',
  'sub.tabEmails': 'E-mail ({count})',
  'sub.addCustomersToInvoiceText': 'Tilføj kunder for at fakturere dem.',
  'sub.removeMember': 'Fjern',
});
